import React, { useEffect, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics } from './firebase';
import { getConsent } from './utils/cookieConsent';
import CriticalCSS from './components/CriticalCSS';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import SeoMeta from './components/SeoMeta';
import HomePage from './pages/HomePage';
import PrivateRoute from "./components/PrivateRoute";

import './App.css';

// Lazy load all non-critical pages to reduce main bundle size
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const RegisterPage = React.lazy(() => import('./pages/RegisterPage'));
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));
const BlogPage = React.lazy(() => import('./pages/BlogPage'));
const BlogPostPage = React.lazy(() => import('./pages/BlogPostPage'));
const AIPlannerLanding = React.lazy(() => import('./pages/AIPlannerLanding'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));
const ItinerarioPage = React.lazy(() => import('./pages/ItinerarioPage'));
const ViajesPage = React.lazy(() => import('./pages/ViajesPage'));
const ForgotPasswordPage = React.lazy(() => import('./pages/ForgotPasswordPage'));
const ResetPasswordPage = React.lazy(() => import('./pages/ResetPasswordPage'));
const VerifyEmailPage = React.lazy(() => import('./pages/VerifyEmailPage'));
const UnsubscribePage = React.lazy(() => import('./pages/Unsubscribe'));

// Loading fallback component
const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  </div>
); 

function AnalyticsListener() {
  const location = useLocation();
  useEffect(() => {
    // if user already consented to analytics, init it
    const c = getConsent();
    if (c && c.analytics) {
      const a = initAnalytics();
      // optionally log page view here if desired
      // if (a) logEvent(a, 'page_view', { page_path: location.pathname });
    }
  }, [location]);
  useEffect(() => {
    function onConsent(e) {
      const detail = e.detail || {};
      if (detail.analytics) {
        initAnalytics();
      }
    }
    window.addEventListener('cookie-consent-changed', onConsent);
    return () => window.removeEventListener('cookie-consent-changed', onConsent);
  }, []);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <CriticalCSS />
      <AnalyticsListener />
      <SeoMeta />
      <Routes>
  {/* Redirect bare routes without language prefix to default language */}
  <Route path="/login" element={<Navigate to="/es/login" replace />} />
  <Route path="/register" element={<Navigate to="/es/register" replace />} />
  <Route path="/dashboard" element={<Navigate to="/es/dashboard" replace />} />
  <Route path="/viajes" element={<Navigate to="/es/viajes" replace />} />
  <Route path="/contact" element={<Navigate to="/es/contact" replace />} />
  <Route path="/blog" element={<Navigate to="/es/blog" replace />} />
  <Route path="/itinerario" element={<Navigate to="/es/itinerario" replace />} />
  <Route path="/privacy-policy" element={<Navigate to="/es/privacy-policy" replace />} />
  <Route path="/planificador-ia" element={<Navigate to="/es/planificador-ia" replace />} />
        {/* Redirección raíz a español por defecto */}
        <Route path="/" element={<Navigate to="/es" replace />} />
        <Route path=":lang" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="planificador-ia" element={
            <Suspense fallback={<PageLoader />}>
              <AIPlannerLanding />
            </Suspense>
          } />
          <Route path="itinerario" element={
            <Suspense fallback={<PageLoader />}>
              <ItinerarioPage />
            </Suspense>
          } />
          <Route path="viajes" element={
            <Suspense fallback={<PageLoader />}>
              <ViajesPage />
            </Suspense>
          } />
          <Route path="login" element={
            <Suspense fallback={<PageLoader />}>
              <LoginPage />
            </Suspense>
          } />
          <Route path="register" element={
            <Suspense fallback={<PageLoader />}>
              <RegisterPage />
            </Suspense>
          } />
          <Route path="contact" element={
            <Suspense fallback={<PageLoader />}>
              <ContactPage />
            </Suspense>
          } />
          <Route path="blog" element={
            <Suspense fallback={<PageLoader />}>
              <BlogPage />
            </Suspense>
          } />
          <Route path="blog/:slug" element={
            <Suspense fallback={<PageLoader />}>
              <BlogPostPage />
            </Suspense>
          } />
          <Route path="dashboard" element={
            <PrivateRoute>
              <Suspense fallback={<PageLoader />}>
                <Dashboard />
              </Suspense>
            </PrivateRoute>
          } />
          <Route path="privacy-policy" element={
            <Suspense fallback={<PageLoader />}>
              <PrivacyPolicy />
            </Suspense>
          } />
          <Route path="forgot-password" element={
            <Suspense fallback={<PageLoader />}>
              <ForgotPasswordPage />
            </Suspense>
          } />
          <Route path="reset-password" element={
            <Suspense fallback={<PageLoader />}>
              <ResetPasswordPage />
            </Suspense>
          } />
          <Route path="verify-email" element={
            <Suspense fallback={<PageLoader />}>
              <VerifyEmailPage />
            </Suspense>
          } />
          <Route path="baja" element={
            <Suspense fallback={<PageLoader />}>
              <UnsubscribePage />
            </Suspense>
          } />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;